import React, { useContext, useEffect, useRef, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import styles from "../../Styles/ComponentStyles/MainPages/Profile.module.scss"
import globalStyles from "../../Styles/global.module.scss"


import { capitalize, useIsBelow1200 } from '../../Utils/Constant/Constant';

import Grid from '@mui/material/Grid2';
import GlobalTabs from '../../Utils/Layout/GlobalTabs/GlobalTabs';
import AppNavbar from '../../Components/AppNavbar/AppNavbar';
import { Avatar, CircularProgress, Menu, MenuItem, Typography } from '@mui/material';
import Icons from '../../Utils/Layout/Icons/Icons';
import { DashboardContext, DashboardDetailPayload } from '../../Context/DashboardDetailContext';
import { UserProfileDetailsPayloadModel } from '../../models/dashboardAxiosModels';
import agent from '../../Services/api';
import { GlobalUserContext, GlobalUserContextPayload } from '../../Context/GlobalUserDetailContext';
import { useSnackbar } from '../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';


const ProfileIndex = () => {

    const { userDetails, setUserDetails } = useContext(DashboardContext) as DashboardDetailPayload

    const {
        setFlagLoader,
        setUserProfileDetails,
        userProfileDetails,

        storedProfileUserUploadId,
        setStoredProfileUserUploadId,


    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const navigate = useNavigate()
    const location = useLocation();
    const isBelow1200 = useIsBelow1200();
    const { showSnackbar } = useSnackbar();

    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const imageInputRef = useRef<HTMLInputElement>(null);
    // const [uploadFileId, setUploadFileId] = useState<number | null>(null)
    const [currentTab, setCurrentTab] = useState<any>("Profile");
    const [profileTabList, setProfileTabList] = useState([
        { label: "Profile", value: "Profile", navigation: "/profile/home" },
        { label: "Acrylic Team", value: "Acrylic Team", navigation: "/profile/view-acrylic-team" },
        { label: "Integration", value: "Integration", navigation: "/profile/integration" },
    ])

    useEffect(() => {
        const path = location.pathname;
        const matchedTab = profileTabList?.find((tab) => path.startsWith(tab.navigation));
        if (matchedTab) {
            setCurrentTab(matchedTab.value);
        }
    }, [location.pathname]);


    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        const selectedTab = profileTabList.find((tab) => tab.value == newValue);
        if (selectedTab) {
            navigate(selectedTab.navigation);
            setCurrentTab(newValue);
        }
    };

    const getUserDetails = async () => {
        try {
            setFlagLoader(true)
            const response = await agent.getUserProfileDetailsAPI.get()
            if (response?.status) {
                setUserDetails(response?.data?.user)
                setUserProfileDetails({
                    ...userProfileDetails,
                    user: {
                        ...userProfileDetails.user,
                        profileImage: response?.data?.user?.profileImage
                    }
                });
                setFlagLoader(false)
            } else {
                const err = response?.error?.message ? response?.error?.message : "Error fetching user details 1";
                showSnackbar(err, 'error')
                setFlagLoader(false)
            }
        } catch (error) {
            showSnackbar("Something Went Wrong", 'error')
        }
    }

    const handleProfileEdit = () => {
        imageInputRef.current?.click();
        handleProfileMenuClose()
    }

    const handleProfileMenuClose = () => {
        setAnchorEl(null);
    };

    const handleProfileMenuClick = (e: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(e.currentTarget);
    };

    const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setIsUploading(true);
        const formData = new FormData();
        formData.append("file", file);

        const response = await agent.uploadResourceFileAPI.post(formData)
        if (response?.status) {
            const responseData = response?.data;
            const uploadedId = responseData.google_storage_id;
            setStoredProfileUserUploadId(uploadedId);
            setIsUploading(false);
            await handleUpdateUserProfileDetails(uploadedId);
        }
        else {
            console.error("Upload failed:", response);
            setIsUploading(false);
        }

        e.target.value = ""
    }

    const handleProfileDelete = async () => {
        setStoredProfileUserUploadId(0)
        handleProfileMenuClose()
        await handleUpdateUserProfileDetails(0)
    }

    const handleUpdateUserProfileDetails = async (overrideUploadId?: number | null) => {

        try {
            setFlagLoader(true)
            setIsUploading(true)
            const payload: UserProfileDetailsPayloadModel = {
                firstName: userDetails?.firstName,
                lastName: userDetails?.lastName,
                agencyName: userDetails?.agencyName,
                contact: userDetails?.contact,
                addressLine1: userDetails?.addressLine1 ? userDetails?.addressLine1 : "",
                addressLine2: userDetails?.addressLine2 ? userDetails?.addressLine2 : "",
                city: userDetails?.city ? userDetails?.city : "",
                zipcode: userDetails?.zipcode ? userDetails?.zipcode : "",
                stateID: userDetails?.stateID ? userDetails?.stateID : "",
                profileImage: overrideUploadId ?? storedProfileUserUploadId ?? 0,

            }

            const response = await agent.userProfileDetailsUpdateAPI.put(payload)
            if (response?.status) {
                setUserDetails(response?.data?.user)
                setIsUploading(false)
                setFlagLoader(false)
                showSnackbar("Details updated successfully", 'success')
                getUserDetails()
            }
            else {
                const err = response?.message || response?.data?.error?.message || "Error updating user details.";
                showSnackbar(err, 'error')
                setFlagLoader(false)
                setIsUploading(false)
            }
        } catch (error) {
            showSnackbar("Something Went Wrong", 'error')
        }
    }


    return (
        <>
            {!isBelow1200 &&
                <AppNavbar />
            }

            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <Grid container>
                        <Grid size={{ xs: 12 }} sx={{ margin: "20px 0px" }}>
                            <Grid container className={`${styles.profileImageContainer}`}>
                                <Grid className={`${styles.profileImageItem}`}>
                                    <Avatar
                                        src={userDetails?.profileImage ? userDetails?.profileImage : ""}
                                        sx={{
                                            width: "100%",
                                            height: "100px"
                                        }}
                                    />
                                    {isUploading &&
                                        <div style={{
                                            position: "absolute", zIndex: 2, top: "30px", left: "30px"
                                        }}><CircularProgress />
                                        </div>
                                    }
                                    <div className={`${styles.profileEditImageItem}`} onClick={handleProfileMenuClick}>
                                        <Icons iconName="editIcon" iconHeight="25px" iconWidth="25px" />
                                    </div>
                                    <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={handleProfileMenuClose}
                                    >
                                        <MenuItem onClick={handleProfileEdit}>Change Photo</MenuItem>
                                        {userDetails?.profileImage &&
                                            <MenuItem onClick={handleProfileDelete}>Remove Photo</MenuItem>
                                        }
                                    </Menu>
                                    <input
                                        id="avatar"
                                        accept="image/*"
                                        type="file"
                                        ref={imageInputRef}
                                        style={{ display: "none" }}
                                        onChange={handleImageUpload}
                                    />
                                </Grid>
                                <Grid className={`${styles.profileContentItem}`}>
                                    <Grid container>
                                        <Grid size={{ xs: 12 }} sx={{ margin: "2px 0px" }}>
                                            <Typography
                                                component={'span'}
                                                className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV18} ${globalStyles.gblOnelineEllipsis}`}
                                                sx={{ display: "block !important" }}
                                            >
                                                {(userDetails?.firstName ? capitalize(userDetails?.firstName) : "") + " " + (userDetails?.lastName ? capitalize(userDetails?.lastName) : "")}
                                            </Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12 }} sx={{ margin: "2px 0px" }}>
                                            <Typography
                                                component={'span'}
                                                className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15} ${globalStyles.gblOnelineEllipsis}`}
                                                sx={{ display: "block !important" }}
                                            >
                                                {userDetails?.email}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <GlobalTabs
                                tabs={profileTabList}
                                currentTab={currentTab}
                                onChange={(event: React.SyntheticEvent, newValue: string) => handleTabChange(event, newValue)}
                                sxTabStyle={{
                                    textTransform: 'none',
                                    color: '#7E7E7E',
                                    marginRight: '20px',
                                    fontWeight: 'normal',
                                    fontSize: '1rem',
                                    '&.Mui-selected': {
                                        color: '#ffffff',
                                        fontWeight: 'bold',
                                    }
                                }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <Outlet />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ProfileIndex